import { Skeleton } from '../Skeleton';

/**
 * Loading rows at the **real column count**, so the table does not reflow when
 * the payload arrives — which is the whole of this repo's CLS budget on a table
 * route.
 *
 * This is the table half of the skeleton vocabulary, and it lives beside the
 * table primitives rather than in `ui/Skeleton.tsx` because a `<tr>` is valid
 * only inside a table: every other placeholder shape on this host is a block and
 * is composed from `ui/Skeleton.tsx`.
 *
 * The shapes are `aria-hidden` behind one polite `role="status"` announcement
 * owned by the surface: a skeleton announced per cell is a screen reader reading
 * a loading state forty times.
 *
 * The sweep is a travelling highlight rather than a whole-block fade — over a
 * grid of cells a fade reads as the table flickering — and it stops dead under
 * `prefers-reduced-motion`, where the global rule in `styles/global.css`
 * collapses every animation to one frame and leaves the shape standing.
 */
export function RowSkeleton({ columns, rows = 3 }: { columns: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <tr key={rowIndex} aria-hidden="true">
          {Array.from({ length: columns }, (_, columnIndex) => (
            <td key={columnIndex}>
              <Skeleton className="h-4 w-full" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
